import { SfStarIcon as SfStarIconFill } from 'fitify-ui/src/Icon/fill/SfStarIcon'
import { SfStarIcon as SfStarIconOutline } from 'fitify-ui/src/Icon/outline/SfStarIcon'
import type { CSSProperties } from 'react'

import {
  StyledContainer,
  StyledInfo,
  StyledRatingRow,
  StyledReviewText,
  StyledStarsContainer,
  StyledTitle,
  StyledUserInfo,
} from './ReviewCard.Styled'

interface ReviewCardProps {
  title: string
  rating: number
  subtitle: string
  reviewText: string
  width?: string
  height?: number
  maxWidth?: CSSProperties['maxWidth']
}

export const ReviewCard = ({
  title,
  rating,
  subtitle,
  reviewText,
  width,
  height,
  maxWidth,
}: ReviewCardProps) => {
  const fullStars = Math.floor(rating)
  const totalStars = 5

  return (
    <StyledContainer $width={width} $height={height} $maxWidth={maxWidth}>
      <StyledInfo>
        <StyledTitle $variant="Poppins/T2 - Semibold">{title}</StyledTitle>
        <StyledRatingRow>
          <StyledStarsContainer>
            {Array.from({ length: totalStars }).map((_, index) => {
              const isFilled = index < fullStars
              return isFilled ? (
                <SfStarIconFill key={index} />
              ) : (
                <SfStarIconOutline key={index} />
              )
            })}
          </StyledStarsContainer>
          <StyledUserInfo $variant="Poppins/T4">{subtitle}</StyledUserInfo>
        </StyledRatingRow>
      </StyledInfo>
      <StyledReviewText $variant="Poppins/T4">{reviewText}</StyledReviewText>
    </StyledContainer>
  )
}
